<div class="m-0" fxLayout="row" fxLayoutAlign="start center">
  <button
    mat-icon-button
    color="primary"
    (click)="onDelete()"
    aria-label="Delete filter"
  >
    <mat-icon>delete</mat-icon>
  </button>
  <div
    fxFlex
    fxLayout="column"
    [class.warning]="selectedFilter.showFieldDeletedWarning"
  >
    <div fxFlex fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
      <mat-form-field
        appearance="outline"
        floatLabel="always"
        fxFlex="35"
        [class.mat-form-field-invalid]="
          selectedFilter.isFilterApplied && !selectedFilter.filter
        "
        class="extra-compact-field"
        subscriptSizing="dynamic"
      >
        <input
          type="text"
          placeholder="Search filters..."
          matInput
          [formControl]="myControl"
          [matAutocomplete]="auto"
          aria-label="Search for a filter"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayFn"
          (optionSelected)="autocompleteSelectedChanged($event.option.value)"
        >
          @for (group of filteredOptions | async; track group) {
            <div class="select-group">
              <p>{{ group.name }}</p>
              @for (filter of group.filters; track filter) {
                <mat-option [value]="filter">{{
                  filter.displayName
                }}</mat-option>
              }
              <mat-divider></mat-divider>
            </div>
          }
        </mat-autocomplete>
      </mat-form-field>
      @if (selectedFilter.filter) {
        <mat-form-field
          appearance="outline"
          floatLabel="always"
          [class.mat-form-field-invalid]="
            selectedFilter.isFilterApplied && !selectedFilter.filterOperator
          "
          class="extra-compact-field odata-operators"
          subscriptSizing="dynamic"
        >
          <mat-select
            [(ngModel)]="selectedFilter.filterOperator"
            (selectionChange)="onOperatorsSelectionChange()"
            aria-label="Select an operator"
          >
            @for (op of operators; track op) {
              <mat-option [value]="op">{{ op.displayName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (selectedFilter.filterOperator?.isSearchValueNeeded) {
          <div fxFlex>
            @if (selectedFilter.uiType == uiType.Multiselect) {
              <multiselect
                [compactSize]="true"
                class="w-100"
                [items]="multiselectItems"
                [selectedItems]="selectedMultiselectItems"
                (selectionChanged)="multiselectSelectionChanged($event)"
                [placeholder]="'Select items...'"
                [required]="selectedFilter.isFilterApplied"
                [isTouched]="selectedFilter.isFilterApplied"
                aria-label="Select a value or values"
              ></multiselect>
            } @else if (selectedFilter.uiType == uiType.DropDown) {
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                fxFlex
                class="dropdown-field extra-compact-field"
                subscriptSizing="dynamic"
                [class.mat-form-field-invalid]="
                  selectedFilter.isFilterApplied &&
                  (selectedFilter.searchValue == null ||
                    selectedFilter.searchValue.toString() == '')
                "
              >
                <mat-select
                  [(ngModel)]="selectedFilter.searchValue"
                  (selectionChange)="selectedFilter.isFilterApplied = false"
                  aria-label="Select a value"
                >
                  @if (
                    selectedFilter.filterOperator.behaveAs == 'List' ||
                    selectedFilter.filter.valueType == 'List'
                  ) {
                    @for (value of listItems; track value) {
                      <mat-option [value]="value">{{ value }}</mat-option>
                    }
                  }
                  @if (selectedFilter.filter.valueType == 'Boolean') {
                    @for (value of selectedFilter.filter.values; track value) {
                      <mat-option [value]="value.searchValue">{{
                        value.name
                      }}</mat-option>
                    }
                  }
                </mat-select>
              </mat-form-field>
            } @else if (selectedFilter.uiType == uiType.Textbox) {
              <mat-form-field
                class="w-100"
                appearance="outline"
                fxFlex
                class="extra-compact-field"
                subscriptSizing="dynamic"
                [class.mat-form-field-invalid]="
                  selectedFilter.isFilterApplied && !selectedFilter.searchValue
                "
              >
                <input
                  matInput
                  [type]="inputType"
                  [(ngModel)]="selectedFilter.searchValue"
                  (change)="
                    selectedFilter.searchValue =
                      selectedFilter.searchValue.trim()
                  "
                  (ngModelChange)="selectedFilter.isFilterApplied = false"
                  [placeholder]="textBoxPlaceholder"
                  aria-label="Type a value"
                />
              </mat-form-field>
            } @else if (selectedFilter.uiType == uiType.DatePicker) {
              <mat-form-field
                appearance="outline"
                class="w-100"
                fxFlex
                class="extra-compact-field"
                subscriptSizing="dynamic"
                [class.mat-form-field-invalid]="
                  selectedFilter.isFilterApplied && !selectedFilter.searchValue
                "
              >
                <input
                  matInput
                  [matDatepicker]="datePicker"
                  [(ngModel)]="selectedFilter.searchValue"
                  (ngModelChange)="selectedFilter.isFilterApplied = false"
                  aria-label="Select or type a date value"
                />
                <mat-datepicker-toggle matSuffix [for]="datePicker">
                </mat-datepicker-toggle>
                <mat-datepicker #datePicker></mat-datepicker>
              </mat-form-field>
            }
          </div>
        }
      }
      @if (showAddConditionButton) {
        <button
          class="add-filter-button"
          mat-button
          color="primary"
          (click)="onAddSubFilter()"
        >
          <mat-icon>add</mat-icon>Add Condition
        </button>
      }
    </div>
  </div>
</div>
@if (selectedFilter.showFieldDeletedWarning) {
  <p class="error-message">
    This field no longer exists. Remove it from the saved view and then select
    Save Changes.
  </p>
}
